var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,8c-0.5522,0-1-0.4478-1-1V2c0-0.5522,0.4478-1,1-1s1,0.4478,1,1v5C17,7.5522,16.5522,8,16,8z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,8c-0.5522,0-1-0.4478-1-1V2c0-0.5522,0.4478-1,1-1s1,0.4478,1,1v5C12,7.5522,11.5522,8,11,8z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,8c-0.5527,0-1-0.4478-1-1V2c0-0.5522,0.4473-1,1-1s1,0.4478,1,1v5C22,7.5522,21.5527,8,21,8z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.5522,0-1-0.4478-1-1v-5c0-0.5522,0.4478-1,1-1s1,0.4478,1,1v5C17,30.5522,16.5522,31,16,31z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,31c-0.5522,0-1-0.4478-1-1v-5c0-0.5522,0.4478-1,1-1s1,0.4478,1,1v5C12,30.5522,11.5522,31,11,31z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,31c-0.5527,0-1-0.4478-1-1v-5c0-0.5522,0.4473-1,1-1s1,0.4478,1,1v5C22,30.5522,21.5527,31,21,31z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,17h-5c-0.5527,0-1-0.4478-1-1s0.4473-1,1-1h5c0.5527,0,1,0.4478,1,1S30.5527,17,30,17z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,12h-5c-0.5527,0-1-0.4478-1-1s0.4473-1,1-1h5c0.5527,0,1,0.4478,1,1S30.5527,12,30,12z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,22h-5c-0.5527,0-1-0.4478-1-1s0.4473-1,1-1h5c0.5527,0,1,0.4478,1,1S30.5527,22,30,22z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,17H2c-0.5522,0-1-0.4478-1-1s0.4478-1,1-1h5c0.5522,0,1,0.4478,1,1S7.5522,17,7,17z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,12H2c-0.5522,0-1-0.4478-1-1s0.4478-1,1-1h5c0.5522,0,1,0.4478,1,1S7.5522,12,7,12z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,22H2c-0.5522,0-1-0.4478-1-1s0.4478-1,1-1h5c0.5522,0,1,0.4478,1,1S7.5522,22,7,22z",
    fill: "#00ACBA"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,26H9c-1.6543,0-3-1.3457-3-3V9c0-1.6543,1.3457-3,3-3h14c1.6543,0,3,1.3457,3,3v14    C26,24.6543,24.6543,26,23,26z M9,8C8.4487,8,8,8.4487,8,9v14c0,0.5513,0.4487,1,1,1h14c0.5518,0,1-0.4487,1-1V9    c0-0.5513-0.4482-1-1-1H9z",
    fill: "#0181B0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,23h-6c-0.5522,0-1-0.4478-1-1v-1c0-0.5513-0.4487-1-1-1h-1c-0.5522,0-1-0.4478-1-1v-6    c0-0.5522,0.4478-1,1-1h1c0.5513,0,1-0.4487,1-1v-1c0-0.5522,0.4478-1,1-1h6c0.5527,0,1,0.4478,1,1v1c0,0.5513,0.4482,1,1,1h1    c0.5527,0,1,0.4478,1,1v6c0,0.5522-0.4473,1-1,1h-1c-0.5518,0-1,0.4487-1,1v1C20,22.5522,19.5527,23,19,23z M14,21h4    c0-1.6543,1.3457-3,3-3v-4c-1.6543,0-3-1.3457-3-3h-4c0,1.6543-1.3457,3-3,3v4C12.6543,18,14,19.3457,14,21z",
    fill: "#F5D803"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.80615d0cad243179517ce8e37556a4d1.svg";
export { ForwardRef as ReactComponent };